const FILTERS_PREFIX = "fl:filters:";
const SORT_PREFIX = "fl:sort:";

function safeGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* quota or disabled */
  }
}

export function loadFilters(category) {
  if (!category) return {};
  const raw = safeGet(`${FILTERS_PREFIX}${category}`);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function saveFilters(category, filters) {
  if (!category) return;
  const value =
    filters && typeof filters === "object" ? JSON.stringify(filters) : "{}";
  safeSet(`${FILTERS_PREFIX}${category}`, value);
}

export function loadSort(category) {
  if (!category) return "";
  return safeGet(`${SORT_PREFIX}${category}`) || "";
}

export function saveSort(category, sort) {
  if (!category) return;
  safeSet(`${SORT_PREFIX}${category}`, sort ? String(sort) : "");
}
